import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";

const useCancelRouting = (relabelCaseService: RelabelCaseService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: cancelRouting, isPending: isCancelling } = useMutation({
    mutationFn: (caseId: string) => relabelCaseService.cancelRouting(caseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.buildingPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletLocations() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedRelabelCases() });
      onSuccess?.();
    }
  });

  return { cancelRouting, isCancelling };
};

export { useCancelRouting };
